export const validation = {
  titleMaxChar: 50,
  paragraphMaxChar: 100,
  blockTitleMaxChar: 30,
  blocks: {
    min: 2,
    max: 30
  }
}